
export const isUnsignedInteger = (s) => {
  return (s) ? (`${s}`.match(/^\d+$/) !== null) : false
}
